<template>
  <!-- :before-close="handleClose" -->
  <el-dialog :title="title"
             :visible.sync="visible"
             :width="myWidth">
    <slot name="content"></slot>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">Cancle</el-button>
      <el-button type="primary"
                 @click="sure">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return "Title";
      }
    },
    myVisible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    myWidth: {
      type: String,
      default() {
        return "25%";
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleClose(done) {
      this.$confirm("Sure？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    sure() {
      this.$emit("dialogSure");
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.myVisible;
      },
      set: function (val) {
        this.$emit("changes", val);
      }
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
</style>
